export default "__VITE_ASSET__D$SR4s92__"